export default "__VITE_ASSET__D_RvzQp6__"